import { Button, Card, Flex, Input, toast } from '@fareye/ui'
import { cancelToken, post } from '@fareye/utils'
import { ErrorMessage, Form, Formik } from 'formik'
import React from 'react'
import { number, object, string } from 'yup'
import * as Yup from 'yup'
import {
  IssueContainerFlex,
  IssueHeadingText,
  IssueLabelText,
  IssueValueFlex
} from '../../../../style/styled'
import { IIssueListingApiConfig } from '../../../../utility/types'
import CustomErrorMessage from '../ErrorMessage'

export interface IUserForm {
  setShowUser: (val: any) => void
  setComment: (val: any) => void
  comment: any
  baseUrl: string
  config: IIssueListingApiConfig
  t: (val: string) => any
}
export interface IUser {
  full_name: string
  email: string
  phone_no: string
  designation: string
}
Yup.addMethod(Yup.string, 'emailValidator', function() {
  return this.test({
    name: 'emailValidator',
    message: '*Emails outside fareye domain can only be tagged',
    test: (email = '') => {
      if (email.includes('fareye.com')) {
        return false
      }
      return true
    }
  })
})

const UserForm = ({
  setShowUser,
  setComment,
  comment,
  baseUrl,
  config,
  t
}: IUserForm) => {
  const [showLoading, setShowLoading] = React.useState(false)
  const initialState = {
    full_name: '',
    email: '',
    phone_no: '',
    designation: ''
  }
  const source = cancelToken().source()
  const validationSchema = object().shape({
    full_name: string().required(t('* Required')),
    email: (string()
      .email(t('* Enter Valid Email'))
      .required(t('* Required')) as any).emailValidator(),
    phone_no: number()
      .required(t('* Required'))
      .max(9999999999, t('* Invalid Number'))
      .min(1111111111, t('* Invalid Number')),
    designation: string().required(t('* Required'))
  })
  const addUser = async (fields: IUser) => {
    try {
      setShowLoading(true)
      const { apiURL } = config.children.addUser.config.apiConfig
      const url = `${baseUrl}${apiURL}`
      const resp = await post(url, { alert_user: fields }, source.token, {
        validateStatus: status => {
          return true
        }
      })
      if (resp.status > 300) {
        const error: any = new Error()
        const error_message = resp.data.error
        if (error_message) {
          error.response = { data: { error_message: error_message } }
        }
        throw error
      }
      const { user } = resp.data
      const cloneComment = `@[${user.email}](email:${user.id})`
      setShowLoading(false)
      setComment(cloneComment)
      setShowUser(false)
      toast.success(t('User Created Successfully..'))
    } catch (ex:any) {
      setShowLoading(false)
      try {
        const {
          data: { error_message }
        } = ex.response
        toast.error(t(error_message))
      } catch (ex:any) {
        toast.error(t('Something went wrong...'))
        console.error(ex)
      }
    }
  }
  return (
    <Card bodyStyle={{ padding: '5px 10px' }} variant="m" m={1} bg={'white'}>
      <Formik
        initialValues={initialState}
        onSubmit={fields => {
          addUser(fields)
        }}
        validationSchema={validationSchema}
        render={({
          handleReset,
          handleSubmit,
          handleChange,
          setFieldTouched,
          isValid,
          errors
        }) => (
          <Form>
            <IssueHeadingText>{t('Add new user')}</IssueHeadingText>
            <IssueContainerFlex justifyContentSpaceBetween>
              <IssueLabelText>{t('Full Name')}</IssueLabelText>
              <IssueValueFlex column>
                <Input
                  placeholder={t('Enter full name')}
                  onChange={handleChange}
                  onBlur={() => {
                    setFieldTouched('full_name', true)
                  }}
                  type="text"
                  name="full_name"
                />
                <ErrorMessage component={CustomErrorMessage} name="full_name" />
              </IssueValueFlex>
            </IssueContainerFlex>
            <IssueContainerFlex justifyContentSpaceBetween>
              <IssueLabelText>{t('Email')}</IssueLabelText>
              <IssueValueFlex column>
                <Input
                  placeholder={t('Enter email')}
                  onChange={handleChange}
                  onBlur={() => {
                    setFieldTouched('email', true)
                  }}
                  type="text"
                  name="email"
                />
                <ErrorMessage component={CustomErrorMessage} name="email" />
              </IssueValueFlex>
            </IssueContainerFlex>
            <IssueContainerFlex justifyContentSpaceBetween>
              <IssueLabelText>{t('Phone No')}</IssueLabelText>
              <IssueValueFlex column>
                <Input
                  placeholder={t('Enter phone no')}
                  onChange={handleChange}
                  onBlur={() => {
                    setFieldTouched('phone_no', true)
                  }}
                  type="number"
                  name="phone_no"
                />
                <ErrorMessage component={CustomErrorMessage} name="phone_no" />
              </IssueValueFlex>
            </IssueContainerFlex>
            <IssueContainerFlex justifyContentSpaceBetween>
              <IssueLabelText>{t('Designation')} </IssueLabelText>
              <IssueValueFlex column>
                <Input
                  placeholder={t('Enter designation')}
                  onChange={handleChange}
                  onBlur={() => {
                    setFieldTouched('designation', true)
                  }}
                  name="designation"
                />
                <ErrorMessage
                  component={CustomErrorMessage}
                  name="designation"
                />
              </IssueValueFlex>
            </IssueContainerFlex>
            <Flex style={{ marginTop: '20px' }} justifyContentFlexEnd>
              <Button
                style={{ marginRight: '10px' }}
                type="button"
                variant="danger"
                onClick={() => {
                  handleReset()
                  setShowUser(false)
                }}
              >
                {t('Cancel')}
              </Button>
              <Button
                type="Submit"
                disabled={!isValid}
                variant="primary"
                isLoading={showLoading}
                onClick={handleSubmit}
              >
                {t('Add User')}
              </Button>
            </Flex>
          </Form>
        )}
      />
    </Card>
  )
}
export default UserForm
